<template>
  <section class="hero-section hidden-section">
    <div class="media-container bg-parallax-wrap-gradien"
         style="background-image: url(/assets/images/backgrounds/bghome.jpg); background-repeat: no-repeat; background-size: cover">
      <div class="bg-wrap bg-parallax-wrap-gradien">
        <div class="bg par-elem " data-bg="images/bg/10.jpg" data-scrollax="properties: { translateY: '30%' }"
             style="background-image: url(../../assets/images/backgrounds/bghome.jpg); transform: translateZ(0px) translateY(-3.83912%);"></div>
      </div>
    </div>
    <div class="container">
      <div class="hero-title hero-title_center">
        <h4>Kodi Kenya</h4>
        <h2>
          Property Management your way!
        </h2>
      </div>
      <div class="main-search-input-wrap shadow_msiw msiw-center">
        <!--        <form method="get" action="/properties">-->
        <!--          <div class="main-search-input fl-wrap">-->
        <!--            <div class="main-search-input-item">-->
        <!--              <input type="text" placeholder="What are you looking for?" value="" name="search">-->
        <!--            </div>-->
        <!--            <div class="main-search-input-item">-->
        <!--              <select data-placeholder="All Categories" class="chosen-select no-search-select" style="display: none;">-->
        <!--                <option>All Statuses</option>-->
        <!--                <option>For Rent</option>-->
        <!--                <option>For Sale</option>-->
        <!--              </select>-->
        <!--              <div class="nice-select chosen-select no-search-select" tabindex="0"><span-->
        <!--                  class="current">All Statuses</span>-->
        <!--                <div class="nice-select-search-box"><input type="text" class="nice-select-search"-->
        <!--                                                           placeholder="Search...">-->
        <!--                </div>-->
        <!--                <ul class="list">-->
        <!--                  <li data-value="All Statuses" class="option selected">All Statuses</li>-->
        <!--                  <li data-value="For Rent" class="option">For Rent</li>-->
        <!--                  <li data-value="For Sale" class="option">For Sale</li>-->
        <!--                </ul>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="main-search-input-item">-->
        <!--              <div class="">-->
        <!--                <el-select v-model="search.county_id"-->
        <!--                           name="location"-->
        <!--                           placeholder="Select Location"-->
        <!--                           style="width: 100% !important;" filterable>-->
        <!--                  <el-option v-for="county in counties?.data"-->
        <!--                             :key="county.id"-->
        <!--                             :label="county.name"-->
        <!--                             :value="county.id">-->
        <!--                  </el-option>-->
        <!--                </el-select>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <button type="submit" class="main-search-button color-bg"> Search-->
        <!--              <i class="far fa-search"></i>-->
        <!--            </button>-->
        <!--          </div>-->
        <!--        </form>-->
      </div>
      <!--      <div class="hero-notifer hn_center fl-wrap">Need more search options?-->
      <!--        <a href="/properties">Advanced Search</a>-->
      <!--      </div>-->
      <div class="scroll-down-wrap sdw_center">
        <div class="mousey">
          <div class="scroller"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SliderComponent",
  data() {
    return {
      search: {}
    }
  },
}
</script>
